<div class="container">

  <div class="grid">
    <div class="col-12">
      <h3>Venda Direta - Seleção de Planos</h3>
    </div>
  </div>

  <div class="grid">
    <div class="col-12">
      <button pButton type="button" (click)="buttonComeBack()" icon="pi pi-angle-double-left" iconPos="left">
        {{'TRANSLATE.RETURN' | translate }}
      </button>
      <button pButton type="button" (click)="buttonPlan()" icon="pi pi-trash" iconPos="left">
        {{ 'TRANSLATE.CLEAR.PLAN' | translate }}
      </button>
      <button pButton type="button" (click)="buttonNextWindow()" icon="pi pi-angle-double-right" iconPos="right"
        class="ui-button-success">
        {{ 'TRANSLATE.ADVANCE' | translate }}
      </button>
    </div>
  </div>

  <div class="grid">
    <div class="col-12">

      <p-accordion [multiple]="true">
        @for (planSelection of planSelectionList; track planSelection) {
          <p-accordionTab header="{{planSelection.tma}}">
            <div class="ui-g">
              <div class="ui-g-12 ui-md-2">
                <span class="title">{{planSelection.tma}}</span>
                <div
                  style="width: 40%; height: 80%; display: table-cell; justify-content: top; align-items: top; margin-left: 75px;">
                  <img src="../../../assets/image/vin/ka.png" alt="">
                </div>
              </div>
              <div class="ui-g-12 ui-md-10 ui-g-nopad">
                <div class="ui-g-12 ui-g-nopad">
                  <div class="ui-g p-justify-center">
                    <div class="ui-g-1 ui-md-1 "><span class="col">{{'VIN.MOTOR' | translate}}</span>
                  </div>
                  <div class="ui-g-1 ui-md-1 "><span class="col">{{'VIN.MODELYEAR' |
                  translate}}</span></div>
                  <div class="ui-g-1 ui-md-1 "><span class="col">{{'VIN.QTD' | translate}}</span>
                </div>
                <div class="ui-g-4 ui-md-4 "><span class="col">{{'VIN.PLANO' | translate}}</span>
              </div>
              <div class="ui-g-2 ui-md-2 "><span class="col">{{'VIN.VALOR' | translate}}</span>
            </div>
            <div class="ui-g-2 ui-md-2 "><span class="col">{{'VIN.TOTAL' | translate}}</span>
          </div>
        </div>
        @for (motorAndModelYearGrouping of planSelection.motorAndModelYearGrouping; track motorAndModelYearGrouping) {
          <div class="ui-g "
            >
            <div class="ui-g-1 ui-md-1" style="margin-left: 25px;">
              <input style="height: 34px;" disabled class="input" type="text" pInputText
                [(ngModel)]="motorAndModelYearGrouping.motorDesc" />
              </div>
              <div class="ui-g-1 ui-md-1">
                <input style="height: 34px;" disabled class="input" type="text" pInputText
                  [(ngModel)]="motorAndModelYearGrouping.modelYear" />
                </div>
                <div class="ui-g-1 ui-md-1">
                  <input style="height: 34px;" disabled class="input" type="text" pInputText
                    [(ngModel)]="motorAndModelYearGrouping.qtd" />
                  </div>
                  <div class="ui-g-4 ui-md-4">
                    <p-multiSelect #planMultiSelect [options]="selectProducts"
                      [(ngModel)]="motorAndModelYearGrouping.plan"
                      (onChange)="getSelectedProducts($event,motorAndModelYearGrouping); scheduleMultiSelectPanelClose(planMultiSelect)"
                      (onPanelHide)="cancelMultiSelectPanelClose(planMultiSelect)"
                      dropdownIcon="pi pi-search">
                      <ng-template let-value pTemplate="selectedItems">
                        <div style="border-radius: 10px 10px 10px 10px; width: 280px;">
                          @for (val of value; track val) {
                            <div
                              class="ui-multiselected-item-token ui-corner-all">
                              <span>{{getNameProduct(val)}}</span>
                            </div>
                          }
                          @if (!value || value.length === 0) {
                            <span
                              class="ui-multiselected-empty-token ui-corner-all">{{'VIN.CHOOSE'
                            | translate}}</span>
                          }
                        </div>
                      </ng-template>
                      <ng-template let-product pTemplate="item">
                        <div
                          style="font-size: 12px; display: inline-block; vertical-align:middle; margin-top:4px">
                        {{product.label}}</div>
                      </ng-template>
                    </p-multiSelect>
                  </div>
                  <div class="ui-g-2 ui-md-2" style="margin-left: 10px;">
                    <input style="height: 34px; width: 150px;" disabled class="input" currencyMask
                      type="text" pInputText [(ngModel)]="motorAndModelYearGrouping.unitPrice" />
                    </div>
                    <div class="ui-g-2 ui-md-2">
                      <input style="height: 34px; width: 140px;" disabled class="input" currencyMask
                        type="text" pInputText [(ngModel)]="motorAndModelYearGrouping.totalPrice" />
                      </div>
                      <!-- <button pButton type="button" icon="pi pi-pencil" iconPos="left" style="height: 34px;"></button> -->
                    </div>
                  }
                </div>
              </div>
            </div>
          </p-accordionTab>
        }
      </p-accordion>

    </div>
  </div>

</div>